import api from "../../api/cofocusAPI";

const SubspaceAPI = {
  /**
   *
   * @param {String} UID User's ID
   * @param {String} property The property
   * @returns {
   *    success: Boolean,
   *    data: Object, // if request successful, created property is also returned
   * }
   */
  async createOneSubspace(UID, property) {
    if (!UID || !property) return { success: false, error: "Required data not provided for request." };
    return api.getResponseData({
      url: `api/subspaces/${UID}/new`,
      method: "post",
      data: { UID, property },
      withCredentials: true,
    });
  },

  async getSubspaceContents(UID, spaceID, subspaceID, skip = 0) {
    if (!UID || !spaceID || !subspaceID) return { success: false, error: "Required data not provided for request." };
    return api.getResponseData({
      url: `api/subspaces/${UID}/load?spaceID=${spaceID}&subspaceID=${subspaceID}&skip=${skip}`,
      method: "get",
      withCredentials: true,
    });
  },

  async updateSubspaceName(data) {
    if (!data.UID || !data.subspaceID) {
      return { success: false, error: "Required data missing for request." };
    }
    return api.getResponseData({
      url: `api/subspaces/${data.UID}/name`,
      method: "post",
      data: { UID: data.UID, subspaceID: data.subspaceID, name: data.name ?? "" },
      withCredentials: true,
    });
  },

  async deleteSubspace(UID, subspaceID) {
    if (!UID || !subspaceID) return { success: false, error: "Required data not provided for request." };
    return api.getResponseData({
      url: `api/subspaces/${UID}/${subspaceID}`,
      method: "delete",
      withCredentials: true,
    });
  },
};

export default SubspaceAPI;
